/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_Project_ChangedInputs */



/**
* | output |
* | --- |
* | "Project settings, speakers, markers or styles will also change." |
*
* @param {Assistant_Restore_Project_ChangedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_project_changed = /** @type {((inputs?: Assistant_Restore_Project_ChangedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_Project_ChangedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les paramètres du projet, les haut-parleurs, les marqueurs ou les styles seront également modifiés.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekteinstellungen, Lautsprecher, Markierungen oder Stile werden sich ebenfalls ändern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anche le impostazioni del progetto, gli altoparlanti, i marcatori o gli stili subiranno delle modifiche.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки проекта, выступающие, маркеры или стили также изменятся.")
	if (locale === "es") return /** @type {LocalizedString} */ ("También cambiarán la configuración del proyecto, los oradores, los marcadores o los estilos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目设置、扬声器、标记或样式也会发生变化。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの設定、スピーカー、マーカー、スタイルなども変更されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट की सेटिंग्स, स्पीकर, मार्कर या स्टाइल में भी बदलाव हो सकता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As configurações do projeto, os alto-falantes, os marcadores ou os estilos também serão alterados.")
	return /** @type {LocalizedString} */ ("Project settings, speakers, markers or styles will also change.")
});